import { Validators } from "@angular/forms";
import { BasespaceFormControl, BasespaceFormProperties } from "../bs-app-launch-form-control";
import { BsAppLaunchRadioButtonControlComponent } from "./bs-app-launch-radio-button-control.component";
import { isNullOrUndefined } from "util";


export interface IRadioButtonChoice {
    selected: boolean; 
    label: string; 
    value: any; 
}

export interface RadioButtonFormControlProperties extends BasespaceFormProperties<BsAppLaunchRadioButtonControlComponent> {
    choices: IRadioButtonChoice[];
    togglers: any[];
}

// Reference docs: https://dagobah-developer.cloud-test.illumina.com/docs/content/documentation/apptools/formbuilder-overview#RadioButton
// Reference class: src/Cloud.FormBuilder/Models/RadioButton.cs
export class RadioButtonFormControl extends BasespaceFormControl<BsAppLaunchRadioButtonControlComponent> implements RadioButtonFormControlProperties {
    choices: IRadioButtonChoice[];
    togglers: { toggleOnValue: string | number; toggleFields: string | number } [];

    constructor(
        data: RadioButtonFormControlProperties
    ) {
        const { id, componentReference, label, helpText, value, required, requiredMessage, choices, togglers, tabularFieldSetStyling, formControlType } = data;
        super({ id, componentReference, label, helpText, value, required, requiredMessage, tabularFieldSetStyling, formControlType });

        this.choices = choices;
        this.togglers = togglers;

        if(required) {
            this.setValidators(Validators.required);
        }
        
        const initialValue = !isNullOrUndefined(value) ? value : null;
        this.setValue(initialValue);
    }
}